/**
 * Lectura de la lista de **familias de puesto excluidas** de «A nombre de» que se teclea en Jobs.
 *
 * Son códigos de SuccessFactors (`customString35`, p. ej. `50000117`), siempre dígitos. 🔴 Un nombre
 * («Gerentes») o un código con letras no empataría nunca con la ficha y dejaría pasar a esa familia en
 * silencio, así que se marca aquí y el servidor lo rechaza igual.
 */

export interface ProblemaFamilia {
  tipo: 'formato' | 'duplicado';
  valor: string;
}

export interface FamiliasLeidas {
  /** Códigos sin espacios ni repetidos, en el orden escrito. */
  familias: string[];
  problemas: ProblemaFamilia[];
}

const CODIGO = /^\d+$/;

export function leerFamilias(texto: string): FamiliasLeidas {
  const familias: string[] = [];
  const problemas: ProblemaFamilia[] = [];
  const vistos = new Set<string>();

  for (const bruto of (texto ?? '').split(/[,;\s]+/)) {
    const token = bruto.trim();
    if (token === '') continue;

    if (!CODIGO.test(token)) {
      problemas.push({ tipo: 'formato', valor: token });
      continue;
    }
    if (vistos.has(token)) {
      problemas.push({ tipo: 'duplicado', valor: token });
      continue;
    }
    vistos.add(token);
    familias.push(token);
  }

  return { familias, problemas };
}

export interface CambioFamilias {
  anadidas: string[];
  quitadas: string[];
}

/** Qué cambia respecto a lo guardado. Quitar una familia la hace aparecer como emisor. */
export function compararFamilias(antes: readonly string[], despues: readonly string[]): CambioFamilias {
  const previas = new Set(antes);
  const nuevas = new Set(despues);
  return {
    anadidas: [...nuevas].filter((f) => !previas.has(f)).sort(),
    quitadas: [...previas].filter((f) => !nuevas.has(f)).sort(),
  };
}

/** El texto para el `textarea`: uno por línea. */
export function aTextoFamilias(familias: readonly string[]): string {
  return [...familias].join('\n');
}
